'use strict';
moduleConfig.registerModule('eclipseApp.maintenance', ['eclipseApp.core']);
